import FoldersUpdateBatch from '@apps/truevail/admin/components/folders_update_batch'
import TagsUpdateBatch from '@apps/truevail/admin/components/tags_update_batch'
import LibraryAddBatch from '@apps/truevail/admin/components/library_add_batch'
import SocialBatchToken from '@apps/truevail/admin/tokens/social_batch'
import LibraryAdd from '@apps/truevail/admin/components/library_add'
import LibraryToken from '@apps/truevail/admin/tokens/library'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import Import from './import'
import Clone from './clone'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Batches)',
  collection: {
    endpoint: '/api/admin/truevail/agency/social_batches',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (social_batch) => (
        <SocialBatchToken social_batch={ social_batch } />
      ) },
      { label: 't(Campaigns)', key: 'social_campaigns_count', collapsing: true, align: 'right' },
      { label: 't(Publishings)', key: 'publishings_count', collapsing: true, align: 'right' },
      { label: 't(Library)', key: 'library_status', sort: 'status', collapsing: true, align: 'center', format: LibraryToken }
    ],
    criteria: {
      fields: [
        {
          label: 't(Fields)',
          fields: [
            { name: 't(Perspective)', key: 'perspective', type: 'select', multiple: true, options: ['first-person singular','first-person plural'] },
            { name: 't(Language)', key: 'language', type: 'select', multiple: true, options: ['american english','canadian english','french','german','italian'] },
            { name: 't(Status)', key: 'status', type: 'select', multiple: true, options: ['draft','published'], format: StatusToken }
          ]
        }
      ]
    },
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'messages_square',
      title: 't(No Social Batches)',
      text: 't(You have not yet created any social batches)',
      buttons: [
        { label: 't(Create Social Batch)', modal: New }
      ]
    },
    entity: 'social batch',
    selectable: true,
    batch: {
      batch_type: 'truevail_social_batches',
      tasks: [
        { 
          label: 't(Add to Library)', 
          svg: 'book_plus',
          action: 'publish', 
          component: <LibraryAddBatch entity="agency" /> 
        },
        { 
          label: 't(Remove from Library)', 
          svg: 'book_minus',
          action: 'unpublish', 
          config: { entity: 'agency' } 
        },
        { 
          label: 't(Update Folders)',
          svg: 'folder',
          action: 'folder', 
          component: <FoldersUpdateBatch entity="agency" />  
        },
        { 
          label: 't(Update Tags)',
          svg: 'tags',
          action: 'tag', 
          component: <TagsUpdateBatch entity="agency" />  
        }
      ]
    },
    recordTasks: (record) => [
      {
        label: 't(Duplicate Social Batch)',
        svg: 'copy',
        modal: <Clone social_batch={ record } />
      },
      {
        label: 't(Add to Library)',
        svg: 'book_plus',
        show: record.status === 'draft',
        modal: <LibraryAdd scope="agency" entity="social_batches" record={ record } />
      },
      {
        label: 't(Remove from Library)',
        svg: 'book_minus',
        show: record.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/agency/social_batches/${record.id}/unpublish`,
          method: 'PATCH',
          onSuccess: () => context.flash.set('success', 't(Successfully removed this social batch from the library)'),
          onFailure: () => context.flash.set('error', 't(Unable to remove this social batch from the library)')
        }
      },
      {
        label: 't(Delete Social Batch)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this social batch?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/agency/social_batches/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted social batch)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete social batch)')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/agency/social_batches/${record.id}`)
  },
  tasks: {
    svg: 'plus',
    items: [
      { 
        label: 't(Create Social Batch)', 
        svg: 'messages_square',
        modal: New 
      }, 
      {
         label: 't(Import Social Batches)', 
         svg: 'hard_drive_upload',
         modal: Import 
        }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
